import {
  createDataReducerSimpleFetch,
  createDataReducerSimpleSubmit,
} from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";

const orderUnitDetailsDataReducerFetch = createDataReducerSimpleFetch(
  "ORDER_UNIT_DETAILS",
  ["orderUnit", "products"],
);

const orderUnitDetailsDataReducerSubmitProducts = createDataReducerSimpleSubmit(
  "ORDER_UNIT_DETAILS_PRODUCTS",
  ["orderUnit"],
);

const orderUnitDetailsDataReducerSubmitRequestApproval =
  createDataReducerSimpleSubmit("ORDER_UNIT_DETAILS_REQUEST_APPROVAL", [
    "orderUnit",
  ]);

export default reduceReducers(
  orderUnitDetailsDataReducerFetch,
  orderUnitDetailsDataReducerSubmitProducts,
  orderUnitDetailsDataReducerSubmitRequestApproval,
);
